import axios, { AxiosRequestConfig } from "axios";
import { BACKEND_URL } from "../Enums/GameEnums";

export function sendRequest(payload) {

    if (process.env.NODE_ENV === 'development') {
        // do not save data from localhost
        return;
    }

    const config: AxiosRequestConfig = {
        baseURL: BACKEND_URL,
        url: '/data',
        method: 'POST',
        data: payload,
    };

    return axios.request(config).catch(e => console.warn(e));
}